import { ensureSuccessStatusCode, useFetch } from '@/features/fetch'
import type { IResponse } from '@/features/api/extranet'
import type { RattachementDTO } from '@/features/api/extranet/dto/Profil'
import { useAppStateStore } from '@/features/application'

export async function loadRattachements(filteredByContext: boolean, init?: RequestInit) {
  const appState = useAppStateStore()
  if (!init)
    init = {
      sablier: true,
      dialogMode: 'retry',
      appCache: true,
      appCacheAddKey: [appState.contextCourant, appState.utilisateur?.emailAffichage],
      appCacheDurationEnSecondes: 300,
    }

  // Stocke la demande
  const fetch = useFetch('extranet')

  // Ajoute le paramètre boolean dans la query string
  const url = `/rattachements?filteredByContext=${filteredByContext}`

  const response = await fetch(url, init)
  if (response.status === 204) return null

  ensureSuccessStatusCode(response)
  const result = (await response.json()) as IResponse<RattachementDTO[]>

  return result.data
}
